import {Box, List, ListItem, Typography} from "@mui/material";
import Link from "next/link";
import MenuItem from "@/src/_types/menu-item";
import React from "react";

interface FooterMenuProps {
    menuItems: MenuItem[];
}

const FooterMenu: React.FC<FooterMenuProps> = ({menuItems}) => {
    return (
        <>
            <Box sx={{display: "flex", flexDirection: "column", gap: 0.5, mb: 2}}>
                {menuItems.filter((item) => !item.children).map((item, index) => (
                    <Link
                        key={index}
                        href={item.link || "#"}
                        style={{
                            textDecoration: "none",
                            color: "inherit",
                            fontWeight: 400,
                            fontSize: "1rem",
                        }}
                    >
                        {item.label}
                    </Link>
                ))}
            </Box>
            {menuItems.filter((item) => item.children).map((item, index) => (
                <Box key={index} sx={{marginBottom: 2}}>
                    <Typography sx={{marginBottom: 0, fontWeight: 700, fontSize: "1rem"}}>
                        {item.label}
                    </Typography>
                    <List sx={{paddingLeft: 1, listStyleType: "circle"}}>
                        {item.children?.map((child, childIndex) => (
                            <ListItem
                                key={childIndex}
                                sx={{
                                    padding: 0,
                                    listStyleType: "circle",
                                    display: "list-item",
                                }}
                            >
                                <Link
                                    href={child.link || "#"}
                                    style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                        fontSize: ".8rem",
                                    }}
                                >
                                    {child.label}
                                </Link>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            ))}
        </>
    );
};

export default FooterMenu;
